import React, { useState } from "react"
import { Box, FormControlLabel, makeStyles, Radio, RadioGroup, TextField } from "@material-ui/core"
import { withRouter } from "react-router-dom"
import { CreatorActions } from "../Creators"
import { PROCESS_SET, useQueryOrganisationTemplates, useMutationRunAdhocProcess } from "../../data"
import { Blockquote, LoadingSpinner, SearchInput } from ".."
import { TextDivider } from "../TextDivider"
import { useAuth } from "../../services"
import { toId, useJobUtils } from "../../utils"
import { Icon } from "../Icon"
import { ColumnBox } from "../Boxes"

const useStyles = makeStyles((theme) => ({
  row: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const AdhocCreator = withRouter(({ history, onClose }) => {
  const classes = useStyles()
  const { location } = useAuth()
  const { getNavigateToLink } = useJobUtils()
  const [searchText, setSearchText] = useState("")

  const { data, loading } = useQueryOrganisationTemplates({
    variables: { set: PROCESS_SET.ACTIVE_ADHOC, locations: [toId(location)], limit: 100 },
  })
  const [runAdhocProcess, { loading: runAdhocProcessLoading }] = useMutationRunAdhocProcess()

  const [id, setId] = useState(null)
  const [title, setTitle] = useState(null)

  const handleClick = (item) => {
    setId(item.id)
  }
  const handleTitleChange = (event) => {
    setTitle(event.target.value)
  }
  const handleFilter = (text) => {
    setSearchText(text.toLowerCase())
  }

  const handleSubmit = async () => {
    const result = await runAdhocProcess({
      variables: {
        id,
        title,
        location: toId(location),
      },
    })
    history.push(getNavigateToLink(result.data.runAdhocProcess))
  }

  const handleClose = (event, isCancel) => {
    onClose(isCancel)
  }

  const hasFilter = data?.organisationTemplates.items.length > 8

  return (
    <>
      {hasFilter && <SearchInput placeholder="Search" boxProps={{ pl: 0, pr: 0 }} onChange={handleFilter} />}

      {loading && (
        <Box display="flex" justifyContent="center">
          <LoadingSpinner size={60} />
        </Box>
      )}
      {!loading && data?.organisationTemplates.items.length === 0 && (
        <ColumnBox mb={2} justifyContent="center" alignItems="center">
          <Blockquote
            icon={<Icon name="information" />}
            title="You don't have any ad hoc processes available at this location"
            body="If you think this is a mistake, contact your manager to gain access."
          />
        </ColumnBox>
      )}
      {!loading && data?.organisationTemplates.items.length > 0 && (
        <Box mb={1}>
          <RadioGroup>
            {data.organisationTemplates.items
              .filter((item) => !searchText || JSON.stringify(item).toLowerCase().includes(searchText))
              .map((item) => (
                <Box key={item.id}>
                  <TextDivider />
                  <FormControlLabel
                    value={item.name}
                    control={<Radio color="primary" />}
                    label={item.name}
                    className={classes.row}
                    onClick={() => handleClick(item)}
                  />
                  {id === item.id && (
                    <TextField
                      id="jobtitle"
                      fullWidth
                      variant="outlined"
                      label="Enter a title for the new job"
                      onChange={handleTitleChange}
                      required
                      autoFocus
                    />
                  )}
                </Box>
              ))}
          </RadioGroup>
          <TextDivider />
        </Box>
      )}

      <CreatorActions
        id="adhoc-actions"
        onClose={handleClose}
        onSubmit={handleSubmit}
        submitLabel="Run process"
        disableSubmit={!id || !title}
        submitLoading={runAdhocProcessLoading}
      />
    </>
  )
})

export default AdhocCreator
